import {computed, ref, Ref, watch} from "vue";

/**
 * Loading state of a sponsor logo shown in place of the initials.
 *
 * The initials stay visible until the image has actually loaded, so a slow
 * link never shows an empty disc, and they come back if the image fails.
 * The state resets whenever the URL changes.
 */
export default function useSponsorLogo(url: Ref<string | null | undefined>) {
    const loaded = ref(false);
    const failed = ref(false);

    watch(url, () => {
        loaded.value = false;
        failed.value = false;
    });

    /** Render the image element (it may still be loading). */
    const hasLogo = computed(() => !!url.value && !failed.value);

    /** The logo is on screen and the fallback can go. */
    const showLogo = computed(() => hasLogo.value && loaded.value);

    const onLoad = () => {
        loaded.value = true;
    };

    const onError = () => {
        failed.value = true;
    };

    return {hasLogo, showLogo, onLoad, onError};
}
